var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDropArrowPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 24,
  viewBox: "0 0 21 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18 15v3h3v3h-3v3h-3v-3h-3v-3h3v-3zM1 0c6.554 0 10.541 4.184 12 12h5l-2 2h-2v3h-3v2l-2 2-9-9h6C5.598.904.892 0 1 0"
})));
export default SvgDropArrowPlus;